import React from 'react';
import {EASINGS} from '@packages/systems/commerce/constants';
import {withMeta, TypeImplementation} from '@packages/systems/wfdl';
import {TEnum} from '@packages/systems/wfdl-ast';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';

const easingType = withMeta(
  {variant: 'menu', withoutLivePreview: true},
  TEnum(EASINGS)
);

export const EasingsEnum = TypeImplementation.Alias({
  type: easingType,
  render: function RenderEasingsEnum({expr, dispatch}) {
    return <ExpressionEditor expression={expr} dispatch={dispatch} />;
  },
});
